@if(email) {
<span>
    <a class="nova__link email-cell" href="mailto:{{email}}">
        <div>
            <mat-icon class="email-icon">email</mat-icon>
        </div>
        <div class="name-container">
            {{ displayText ?? email }}
        </div>
    </a>
</span>
}